import network from '@/utils/network'

/**
 * Récupère les agences
 * @returns {Promise<>}
 */
export const fetchAgencies = async () => {
  const r = await network.post(`admin/fetch/agencies`)
  return r.data
}

/**
 * Récupère une agence complète
 * @returns {Promise<>}
 */
export const getAdminAgency = async (slug) => {
  const r = await network.get(`admin/agency/${slug}`)
  return r.data
}

/**
 * Met à jour une agence
 * @returns {Promise<>}
 */
export const postAdminAgency = async (agency) => {
  const r = await network.post(`admin/agency`, agency)
  return r.data
}

/**
 * Récupére le chiffres d'affaires réalisées
 * @returns {Promise<>}
 */
export const getTurnOver = async (params) => {
  const r = await network.post(`admin/dashboard/fetch/turnover`, params)
  return r.data
}

/**
 * Récupére des informations diverses sur l'activité
 * @returns {Promise<>}
 */
export const getActivityResume = async (params) => {
  const r = await network.get(`admin/dashboard/resume`, params)
  return r.data
}
